export default "__VITE_ASSET__8312b20a__"